const initState = {
  accessoriesError: null,
  accessories: [],
  dedicatedAccessories: {
    list: {
      left: [],
      center: [],
      right: [],
    },
  },
  dedicatedAccessoriesError: null,
  accessoriesListShopError: null,
  accessoriesListShop: [],
};

const productsReducer = (state = initState, action) => {
  switch (action.type) {
    case 'GET_ACCESSORIES_ERROR':
      return {
        ...state,
        accessoriesError: action.data,
      };
    case 'GET_ACCESSORIES_SUCCESS':
      return {
        ...state,
        accessories: action.data,
        accessoriesError: null,
      };
    case 'GET_DEDICATED_ACCESSORIES_ERROR':
      return {
        ...state,
        dedicatedAccessories: initState.dedicatedAccessories,
        dedicatedAccessoriesError: action.data,
      };
    case 'GET_DEDICATED_ACCESSORIES_SUCCESS':
      return {
        ...state,
        dedicatedAccessories: action.data,
        dedicatedAccessoriesError: null,
      };
    case 'GET_ACCESSORIES_LIST_SHOP_ERROR':
      return {
        ...state,
        accessoriesListShopError: action.data,
      };
    case 'GET_ACCESSORIES_LIST_SHOP_SUCCESS':
      return {
        ...state,
        accessoriesListShop: action.data,
        accessoriesListShopError: null,
      };

    default:
      return state;
  }
};

export default productsReducer;
